import type { Vehicle } from '@repo/domain';
import type { TestId } from '@repo/test-id';
import { Modal } from '@repo/ui';

import VehicleSelectionListingModalContents from '@features/reservation/components/vehicle/VehicleSelectionListingModalContents';

import { PHONE_LAYOUT_CONTAINER_ID } from '@shared/constants/layout';

interface Props {
  testId: TestId;
  open: boolean;
  vehicles: Vehicle[];
  selectedVehicleIds: string[];
  disabled: boolean;
  onVehicleAdd: (vehicleId: string) => void;
  onVehicleRemove: (vehicleId: string) => void;
  onOpenChange: (open: boolean) => void;
  onAddNewVehicle: () => void;
}

export default function VehicleSelectionModal({
  testId,
  open,
  vehicles,
  selectedVehicleIds,
  disabled,
  onVehicleAdd,
  onVehicleRemove,
  onOpenChange,
  onAddNewVehicle,
}: Props) {
  const handleClose = () => {
    onOpenChange(false);
  };

  const portalTarget = document.getElementById(PHONE_LAYOUT_CONTAINER_ID) ?? undefined;

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      testId={testId.append('drawer')}
      portalTo={portalTarget}
      dismissableOnClickOutside={false}
    >
      <VehicleSelectionListingModalContents
        testId={testId}
        vehicles={vehicles}
        selectedVehicleIds={selectedVehicleIds}
        disabled={disabled}
        onVehicleAdd={onVehicleAdd}
        onVehicleRemove={onVehicleRemove}
        onClose={handleClose}
        onAddNewVehicle={onAddNewVehicle}
      />
    </Modal>
  );
}
